var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { Ordering } from '../../../ts/components/Ordering';
function b64EncodeUnicode(str) {
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function toSolidBytes(match, p1) {
        return String.fromCharCode(('0x' + p1));
    }));
}
function b64DecodeUnicode(str) {
    return decodeURIComponent(atob(str).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
}
export class FileUploaders extends Component {
    constructor() {
        super('FileUploader', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.file-uploader').each((fileUploader) => {
                new FileUploader(fileUploader);
            });
            this.success();
        });
    }
}
export class FileUploader {
    constructor(fileUploader) {
        this.defaults = {};
        this.fileUploader = fileUploader;
        this.dataField = this.fileUploader.find('.file-uploader-data');
        this.isMultiple = !(this.fileUploader.find('input[type="file"]').attr('multiple') === null);
        this.maxFiles = parseInt(this.fileUploader.data('maxFiles'));
        this.maxFileSize = parseInt(this.fileUploader.data('maxFileSize'));
        this.visibility = this.fileUploader.data('visibility') ? this.fileUploader.data('visibility') : 'public';
        this.type = this.fileUploader.data('type');
        this.toReduce = this.fileUploader.data('toReduce') == 'true' ? true : false;
        try {
            this.defaults = JSON.parse(atob(this.fileUploader.data('defaults')));
        }
        catch (e) {
        }
        this.fileUploader.on('click', '.remove-file', (event, button) => {
            event.preventDefault();
            this.removeFile(button.parent().index());
        });
        this.fileUploader.find('input[type="file"]').on('change', (event, input) => __awaiter(this, void 0, void 0, function* () {
            if (!isNaN(this.maxFiles) && this.decodeDataInput().length >= this.maxFiles) {
                alert('Vous avez atteint le nombre maximum de fichiers.');
                return;
            }
            input.addClass('disabled is-loading');
            var data = new FormData();
            Object.entries(input.get(0).files).forEach((_a) => __awaiter(this, [_a], void 0, function* ([key, file]) {
                data.append('files[' + key + ']', file);
            }));
            data.append('action', 'hw_upload_files');
            data.append('format', this.type);
            data.append('visibility', this.visibility);
            data.append('to_reduce', this.toReduce ? 'true' : 'false');
            // Check file size limit
            if (!isNaN(this.maxFileSize) && this.maxFileSize > 0) {
                const maxFileSize = this.maxFileSize * 1024 * 1024;
                for (let i = 0; i < input.get(0).files.length; i++) {
                    if (input.get(0).files[i].size > maxFileSize) {
                        alert('Le fichier "' + input.get(0).files[i].name + `" dépasse la taille maximale autorisée de ${this.maxFileSize} Mo.`);
                        input.removeClass('disabled is-loading').val('');
                        return;
                    }
                }
            }
            // use fetch API to send data to server ($.httpRequest is not working with FormData)
            const response = yield fetch('/wp-admin/admin-ajax.php', {
                method: 'POST',
                body: data,
            });
            try {
                const parsedResponse = JSON.parse(yield response.text());
                parsedResponse.forEach((data) => {
                    if (data.error)
                        alert(data.message);
                });
                this.addFile(parsedResponse);
            }
            catch (e) { }
            input.removeClass('disabled is-loading').val('');
        }));
        if (this.isMultiple && (this.type === 'image-extended' || this.type === 'image-copyright')) {
            this.initOrdering();
            this.initCopyright();
            this.addCheckEventHandler('.file-uploader-preview .form-check-input');
        }
    }
    addFile(newFiles) {
        let files = this.isMultiple ? this.decodeDataInput() : [];
        newFiles.forEach((file) => {
            if (file.error)
                return;
            let newFileData = {
                id: file.id,
                url: file.url,
                title: file.filename,
                show_zkp: file.show_zkp,
            };
            if (this.defaults) {
                Object.entries(this.defaults).forEach(([key, value]) => {
                    newFileData[key] = value;
                });
            }
            files.push(newFileData);
        });
        this.encodeDataInput(files);
        if (!this.isMultiple)
            this.fileUploader.find('.uploader-container').addClass('d-none');
        this.preview();
    }
    removeFile(index) {
        return __awaiter(this, void 0, void 0, function* () {
            let files = this.decodeDataInput();
            const response = yield $.httpRequest({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                body: {
                    action: 'hw_remove_file',
                    id: files[index].id
                },
                dataType: 'json'
            });
            if (response.error) {
                alert('Une erreur est survenue.');
                return;
            }
            this.fileUploader.find('.file-uploader-preview').eq(index).remove();
            files.splice(index, 1);
            this.fileUploader.find('.uploader-container').removeClass('d-none');
            this.encodeDataInput(files);
        });
    }
    decodeDataInput() {
        let data = [];
        try {
            data = JSON.parse(b64DecodeUnicode(this.dataField.val()));
        }
        catch (e) {
        }
        return data;
    }
    encodeDataInput(files) {
        try {
            this.dataField.val(b64EncodeUnicode(JSON.stringify(files)));
            this.fileUploader.data('fileCount', files.length.toString());
            this.fileUploader.parents('form').addClass('has-changes');
        }
        catch (e) {
            console.log(e);
        }
    }
    preview() {
        this.fileUploader.find('.file-uploader-preview').empty();
        let files = this.decodeDataInput();
        let previewHTML = '';
        const previewField = this.fileUploader.data('preview') != '' ? this.fileUploader.data('preview') : 'title';
        files.forEach((file) => {
            if (this.type === 'image') {
                previewHTML += '<div class="file-uploader-preview file-uploader-preview-images col position-relative"><div class="img-thumbnail ratio ratio-4x3 bg-cover" style="background-image:url(' + file['url'] + ');"></div><a href="#" class="remove-file">×</a></div>';
            }
            else if (this.type === 'image-copyright') {
                const id = new Date().getTime();
                previewHTML += '<div class="file-uploader-preview file-uploader-preview-images col position-relative" data-id="' + file['id'] + '" id="preview-' + file['id'] + '"><div class="img-thumbnail"><div class="ratio ratio-4x3 bg-cover" style="background-image:url(' + file['url'] + ');"></div><input class="form-control form-control-sm" type="text" placeholder="Crédits image" name="copyright" value="' + file['copyright'] + '"></div><a href="#" class="remove-file">×</a></div>';
            }
            else if (this.type === 'image-extended') {
                const id = new Date().getTime();
                const checked = file['is_featured'] ? 'checked' : '';
                previewHTML += '<div class="file-uploader-preview file-uploader-preview-images col position-relative" data-id="' + file['id'] + '" id="preview-' + file['id'] + '"><div class="img-thumbnail"><div class="ratio ratio-4x3 bg-cover" style="background-image:url(' + file['url'] + ');"></div><input class="form-control form-control-sm" type="text" placeholder="Crédits image" name="copyright" value="' + file['copyright'] + '"><div class="form-check"><input class="form-check-input" type="checkbox" id="check-' + id + '" name="is-featured" ' + checked + ' /><label for="check-' + id + '" class="form-check-label fs-small">Image principale</label></div></div><a href="#" class="remove-file">×</a></div>';
            }
            else {
                previewHTML += '<li class="file-uploader-preview">' + file[previewField] + '<a href="#" class="remove-file">×</a></li>';
            }
        });
        this.fileUploader.find('.file-uploader-previews').html(previewHTML);
        this.initOrdering();
        this.initCopyright();
        // Manage is-featured checkbox
        if (this.type === 'image-extended') {
            this.addCheckEventHandler('.file-uploader-preview .form-check-input');
            this.checkFeatured();
        }
    }
    addCheckEventHandler(target) {
        $('body').on('click', target, (event, preview) => {
            const thumbnailID = preview.parents('.file-uploader-preview').data('id');
            $('[name="vignette_api"]').val(thumbnailID);
            this.fileUploader.find('.file-uploader-preview:not([data-id="' + thumbnailID + '"]) .form-check-input').each((checkbox) => {
                checkbox.get(0).checked = false;
            });
            this.checkFeatured();
        });
    }
    checkFeatured() {
        if (this.fileUploader.find('.form-check-input:checked').length === 0) {
            this.fileUploader.find('.form-check-input').get(0).checked = true;
            this.fileUploader.find('.form-check-input:checked').trigger('click');
        }
    }
    initOrdering() {
        new Ordering(this.fileUploader.find('.file-uploader-previews'), () => {
            let files = this.decodeDataInput();
            // Reorder files according to previews
            this.fileUploader.find('.file-uploader-preview').each((preview) => {
                const id = preview.data('id');
                files.forEach((file, index) => {
                    if (file.id === id) {
                        files.splice(index, 1);
                        files.splice(preview.index(), 0, file);
                    }
                });
            });
            this.encodeDataInput(files);
        });
    }
    initCopyright() {
        this.fileUploader.find('[name="copyright"]').on('change', (event, input) => {
            const preview = input.parents('.file-uploader-preview');
            const id = preview.data('id');
            const files = this.decodeDataInput();
            files.forEach((file) => {
                if (file.id == id) {
                    file['copyright'] = input.val();
                }
            });
            this.encodeDataInput(files);
        });
    }
}
